import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { signinStore } from "./store/auth/signin/signin.store";
import { checkStore } from "./store/auth/check/check.store";
import { tokenValidationStore } from "./store/auth/validate/validate.store";
import { userAssessmentMatchStore } from "./store/user/assessmentMatches/assessmentMatch.store";
import { assessmentTemplateStore } from "./store/assessment/template/template.store";
import { employeeStore } from "./store/company/employees/employee.store";
import { assessmentStore } from "./store/assessment/assessment/assessment.store";
import { assessmentMatchStore } from "./store/assessment/match/index.store";
import { assessmentQuestionStore } from "./store/assessment/question/index.store";
import { companyStore } from "./store/company/company/company.store";
import { companyCategoryStore } from "./store/company/categories/index.store";
import { appStore } from "./store/app/app/app.store";

import "./services";

const rootReducer = combineReducers({
  signin: signinStore.reducer,
  check: checkStore.reducer,
  tokenValidation: tokenValidationStore.reducer,
  userAssessmentMatch: userAssessmentMatchStore.reducer,
  assessmentTemplate: assessmentTemplateStore.reducer,
  employee: employeeStore.reducer,
  assessment: assessmentStore.reducer,
  assessmentMatch: assessmentMatchStore.reducer,
  assessmentQuestion: assessmentQuestionStore.reducer,
  company: companyStore.reducer,
  categories: companyCategoryStore.reducer,
  app: appStore.reducer,
});

// Create the type of store based on rootReducer
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// Configure Store
export const store = configureStore({
  reducer: rootReducer,
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
